import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer, persistStore } from "redux-persist";
import GlobalVariablesReducer from "../redux/reducers/GlobalVariablesSlice";
import UserSettingsReducer from "../redux/reducers/UserSettingsSlice";
import authReducer from "../redux/reducers/authSlice";


// Combine all reducers (if you add more later)
const rootReducer = combineReducers({
    globalVariables: GlobalVariablesReducer,
    userSettings: UserSettingsReducer, // 👈 new slice added
    auth: authReducer,
});

// 🔹 Persist configuration
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["globalVariables", "userSettings", "auth"], // only persist this slice
};

// 🔹 Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 🔹 Create store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // required for redux-persist
        }),
});

// 🔹 Create persistor
export const persistor = persistStore(store);
